/* Native collection navigation: a sort selection submits the GET form once. */
(() => {
  'use strict';
  if (window.NiralaCollectionSort) { window.NiralaCollectionSort.init(); return; }

  function preserveQuery(form) {
    form.querySelectorAll('[data-sort-preserved-query]').forEach(input => input.remove());
    const existing = new Set([...form.elements].filter(input => input.name && !input.disabled).map(input => input.name));
    const current = new URL(window.location.href);
    const action = new URL(form.action, window.location.href);
    const query = new URLSearchParams(action.search);
    for (const name of new Set(current.searchParams.keys())) {
      query.delete(name);
      current.searchParams.getAll(name).forEach(value => query.append(name, value));
    }
    for (const [name, value] of query) {
      if (existing.has(name) || ['page', 'sort_by', 'section_id', 'sections'].includes(name)) continue;
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = name; input.value = value;
      input.dataset.sortPreservedQuery = '';
      form.appendChild(input);
    }
    // Sorting starts from the first page of the new order.
    form.querySelectorAll('[name="page"]').forEach(input => input.remove());
  }

  function init() {
    document.querySelectorAll('[data-collection-sort-form]').forEach(form => {
      if (typeof form.requestSubmit !== 'function') return;
      form.dataset.autoSortReady = 'true';
      const apply = form.querySelector('[data-collection-sort-apply]');
      if (apply) apply.hidden = true;
    });
  }
  document.addEventListener('change', event => {
    const select = event.target.closest?.('[data-collection-sort]');
    const form = select?.form;
    if (!form?.matches('[data-collection-sort-form]') || form.dataset.autoSortReady !== 'true') return;
    preserveQuery(form);
    form.requestSubmit();
  });
  document.addEventListener('shopify:section:load', init);
  window.NiralaCollectionSort = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
